import R from 'ramda';
import React, { PropTypes as pt } from 'react';
import * as Survey from 'survey-react';
import { QuestionForm } from './styles';
import { Modal } from 'antd';

const css = {
  footer: 'text-right',
};

class QuestionView extends React.Component {
  static propTypes = {
    questId: pt.string.isRequired,
    quest: pt.shape({}),
    submitQuestions: pt.func.isRequired,
    onAnswersUpdated: pt.func.isRequired,
    readOnly: pt.bool,
    errors: pt.arrayOf(pt.string).isRequired,
    start_opened: pt.bool,
    code: pt.string,
  };

  static defaultProps = {
    errors: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      survey: null,
      isEmpty: false,
    };
  }

  componentWillReceiveProps = ({ isEmpty }) => {
    isEmpty !== null && this.setState({ isEmpty });
  };

  componentDidMount() {
    this.props.getQuestions(this.props.questId);
  }

  handleSubmit = survey => {
    const success = () => {
      survey.data.code = this.props.code; // Если code приходит как пропс
      survey.data.start_opened = this.props.start_opened; // Если необходимо
      survey.isCompleted = false;
      survey.mode = 'display';
      this.setState({ survey });
      this.props.updateContent && this.props.updateContent();
      return Modal.success({
        title: 'Успешно',
        content: 'Анкета успешно сохранена.',
        okText: 'Ok'
      });
    };
    const error = (e) => {
      return Modal.error({
        title: 'Ошибка отправки',
        content: <p>{e.msg}{e.status && <i> Код ошибки {e.status}</i>}</p>,
        okText: 'Ok'
      });
    };
    this.props.submitQuestions(this.props.questId, survey.data)
      .then(res => {
        const status = res.value.status;
        switch (status) {
        case 200:
        case 201:
        case 204:
          return success();
        case 400:
          return res.value.json()
            .then(data => {
              throw { msg: data.answers[0], status: null };
            });
        default:
          throw { msg: 'Неизвестная ошибка', status: status };
        }
      })
      .catch(error);
  };

  handleValueChanged = survey => this.props.onAnswersUpdated(this.props.questId, survey.data);

  markError = q => {
    if (R.contains(q.name, this.props.quest.errors || [])) {
      q.addError(new Survey.CustomError('Вы неправильно ответили на этот вопрос'));
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.quest !== this.props.quest && this.props.quest && this.props.quest.questions) {
      Survey.defaultBootstrapCss.navigationButton = 'ant-btn egLxVc ant-btn-primary';
      Survey.Survey.cssType = 'bootstrap';
      const survey = new Survey.Model(this.props.quest.questions);
      survey.locale = 'ru';
      if (this.props.quest.is_completed || this.props.readOnly) {
        survey.mode = 'display';
      }
      R.forEach(page => R.forEach(this.markError, page.questions), survey.pages);
      this.setState({ survey });
    }
  }

  render() {
    const { isEmpty } = this.state;
    return (
      <QuestionForm {...{ isEmpty }}>
        {this.state.survey && <Survey.Survey
          model={this.state.survey}
          onComplete={this.handleSubmit}
          data={this.props.quest.answers}
          onValueChanged={this.handleValueChanged}
          css={css}
        />}
      </QuestionForm>
    );
  }
}

export default QuestionView;



// WEBPACK FOOTER //
// ./src/incab/common/components/QuestionView/index.jsx